/* eslint-disable react/jsx-no-target-blank */
import { dateHR } from "@/common/utils/dates";
import { Image } from "components";
import { routes } from "@/common/utils/routes";
import { VerifiedIcon } from "components/UI/VerifiedIcon";

export const UserInfo = (props: {
  name?: string;
  gifId: string;
  userpic?: string;
  verified: boolean;
  createDate: number;
  isStudio: boolean;
}): JSX.Element => {
  if (!props.name) {
    return <></>;
  }

  const gifLink = `${routes.watch(props.gifId)}?from=embed`;

  return (
    <div className="userInfo">
      <a
        href={routes.user(props.name)}
        title="Open user profile page"
        target="_blank"
      >
        <Image className="userpic" src={props.userpic} />
      </a>

      <div className="text">
        <div className="date">
          <a
            href={gifLink}
            target="_blank"
            title="Open gif page"
          >{dateHR(props.createDate)}</a>
        </div>
        <div className="author">
          <a
            href={routes.user(props.name)}
            target="_blank"
            title="Open user profile page"
          >{props.name}</a>
          {props.verified && (
            <VerifiedIcon title={`Video from a verified ${props.isStudio ? "studio" : "user"}`} isStudio={props.isStudio} />
          )}
        </div>
      </div>
    </div>
  );
};
